/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_Release_To_CancelInputs */

const en_us2_coach_mic_release_to_cancel = /** @type {(inputs: Coach_Mic_Release_To_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release to cancel`)
};

const pt_br2_coach_mic_release_to_cancel = /** @type {(inputs: Coach_Mic_Release_To_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solte para cancelar`)
};

const es_419_coach_mic_release_to_cancel = /** @type {(inputs: Coach_Mic_Release_To_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suelta para cancelar`)
};

const pt_pt2_coach_mic_release_to_cancel = /** @type {(inputs: Coach_Mic_Release_To_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Larga para cancelar`)
};

const fr_fr2_coach_mic_release_to_cancel = /** @type {(inputs: Coach_Mic_Release_To_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relâche pour annuler`)
};

const de_de2_coach_mic_release_to_cancel = /** @type {(inputs: Coach_Mic_Release_To_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loslassen zum Abbrechen`)
};

const it_it2_coach_mic_release_to_cancel = /** @type {(inputs: Coach_Mic_Release_To_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilascia per annullare`)
};

/**
* | output |
* | --- |
* | "Release to cancel" |
*
* @param {Coach_Mic_Release_To_CancelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_release_to_cancel = /** @type {((inputs?: Coach_Mic_Release_To_CancelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_Release_To_CancelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_release_to_cancel(inputs)
	if (locale === "es-419") return es_419_coach_mic_release_to_cancel(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_release_to_cancel(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_release_to_cancel(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_release_to_cancel(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_release_to_cancel(inputs)
	return en_us2_coach_mic_release_to_cancel(inputs)
});
export { coach_mic_release_to_cancel as "coach-mic.release_to_cancel" }